import i18n from 'i18next';

export const SapType = [
  { value: 'kit', label: i18n.t("SapItem.TypeKit"), checked:true  },
  { value: 'item', label: i18n.t("SapItem.TypeItem"), checked:true }
];